function AgentSelector({ agents, onSelectAgent }) {
  if (!agents || agents.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">No agents available at this time.</p>
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-900 mb-6">
        Select Your Host
      </h2>

      <div className="grid gap-4 md:grid-cols-2">
        {agents.map((agent) => (
          <button
            key={agent.agentId}
            onClick={() => onSelectAgent(agent)}
            className="text-left bg-white border-2 border-gray-200 rounded-lg p-6 hover:border-primary-500 hover:shadow-md transition-all duration-200 group"
          >
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className="h-12 w-12 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                  <span className="text-xl font-semibold text-primary-600">
                    {agent.name.charAt(0)}
                  </span>
                </div>
              </div>

              <div className="ml-4 flex-1">
                <h3 className="text-lg font-medium text-gray-900 group-hover:text-primary-600">
                  {agent.name}
                </h3>
                <p className="text-sm text-gray-600 mt-1">{agent.title}</p>
                <p className="text-sm text-gray-500 mt-1">{agent.email}</p>
              </div>

              <div className="ml-4">
                <svg
                  className="h-5 w-5 text-gray-400 group-hover:text-primary-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default AgentSelector;
